module.exports = __webpack_public_path__ + "static/media/LockIcon.1ab76d3d.svg";